import { Stack } from "expo-router";
import { useState } from "react";
import { CalendarProvider, type DateData } from "react-native-calendars";
import { Nothing } from "~/components/permission/Nothing";
import { getMonth } from "~/util/dates";

export const unstable_settings = {
    initialRouteName: "index",
};

export default function OnBoardingLayout() {
    const [date, setDate] = useState(getMonth(new Date()));

    const handleMonthChange = (month: DateData) => {
        const parsed = getMonth(month.dateString);

        date === parsed || setDate(parsed);
    };

    return (
        <>
            <Stack.Screen options={{ headerShown: false }} />
            <CalendarProvider date={date} onDateChanged={setDate} onMonthChange={handleMonthChange}>
                <Stack
                    screenOptions={{
                        headerLeft: () => <Nothing />,
                        headerTransparent: true,
                        title: "",
                    }}
                />
            </CalendarProvider>
        </>
    );
}
